<!--
  VueTable 컬럼 dataTable에 checkbox 필터 여부
  @since 2023-12-01
  @author jungmin87.kim
-->

<template>
  <vue-table ref="dataTable"
             :columns="optsColumns"
             :data="optsData"
             :headerVisible="false"
             :height="height"
             :width="width"
             :class="['bs', 'bs-data-table', 'bs-data-table-slim', 'analysis-panel-datatable']"
  >
    <template #body="props">
      <vue-table-tr :props="props">
        <vue-table-td
          v-for="col of props.cols"
          :key="col.field"
          :class="col.align === 'center' ? 'text-center' : ''"
          :props="props">
          <q-checkbox
            v-model="props.row.use"
            :label="props.row.label"
            @input="checkedSelection(props.row.value, props.row.use)"
            class="bs bs-q-checkbox bs-q-checkbox-default marL5 marR5"/>
        </vue-table-td>
      </vue-table-tr>
    </template>
  </vue-table>
</template>

<script>
export default {
  name: 'ColumnListCheckboxFilter',
  props: {
    vueTableProps: {
      type: Object,
      required: true
    },
    opts: { // {label, value}
      type: Array,
      default: () => {}
    },
    height: {
      type: Number,
      default: 145
    },
    width: {
      type: Number,
      default: 120
    }
  },
  data () {
    return {
      optsColumns: [ {field: 'use', name: 'use', label: 'use', tooltip: false} ], // vue-table colums
      optsData: [],
      useIndex: {}
    }
  },
  async mounted () {
    _.forEach(this.opts, opt => {
      if (opt.use) _.set(this.useIndex, opt.value, true)
    })
    const allUse = {label: this.$t('cmn.all'), value: 'ALL', use: Object.keys(this.useIndex).length === 0}
    this.optsData = [allUse, ...this.opts]
    this.setFilterd()
  },
  computed: {
    isAll () { // 선택된 항목이 없다면 전체가 선택되어 있어야 함
      const isUse = _.some(Object.keys(this.useIndex), o => {
        return this.useIndex[o]
      }) && this.opts.length === Object.keys(this.useIndex).length
      return !isUse
    }
  },
  methods: {
    async checkedSelection (key, value) {
      if (key === 'ALL') this.useIndex = {}
      else this.useIndex[key] = value
      const isAllUse = Object.keys(this.useIndex).length === this.opts.length && _.some(Object.keys(this.useIndex), o => {
        return this.useIndex[o]
      })
      const isAllNotUse = _.every(Object.keys(this.useIndex), o => {
        return !this.useIndex[o]
      })
      // 모두 선택되거나 취소되면 전체가 선택되도록 설정
      let allUse = void 0
      if (isAllUse || isAllNotUse) {
        allUse = {label: this.$t('cmn.all'), value: 'ALL', use: true}
        this.useIndex = {}
      } else {
        allUse = {label: this.$t('cmn.all'), value: 'ALL', use: false}
      }
      const usedList = _.cloneDeep(_.map(this.opts, o => {
        return _.assignIn(o, {
          use: _.get(this.useIndex, [o.value], false)
        })
      }))
      this.optsData = [allUse, ...usedList]
      this.onEmit()
    },
    // 필터상태 변경
    setFilterd () {
      const col = this.vueTableProps.col
      const icon = col.headerType[0].props.iconCustomClass
      // 필터 아이콘 색상 변경
      const isFiltered = Object.keys(this.useIndex).length > 0
      if (isFiltered) {
        col.headerType[0].props.iconCustomClass = icon.replace('-filter-b', '-filter-r')
      } else {
        col.headerType[0].props.iconCustomClass = icon.replace('-filter-r', '-filter-b')
      }
    },
    onEmit () {
      this.setFilterd()
      this.$emit('columnFilter', this.useIndex) // useIndex: {[row.value]: true}
    },
    clear (emit = true) {
      this.onEmit()
    },
    // Public
    async injectFilter (filter) {
      this.useIndex = filter
      await this.$nextTick()
      const usedList = _.cloneDeep(_.map(this.opts, o => {
        return _.assignIn(o, {
          use: _.get(this.useIndex, [o.value], false)
        })
      }))
      const allUse = {label: this.$t('cmn.all'), value: 'ALL', use: this.isAll}
      this.optsData = [allUse, ...usedList]
    }
  },
  beforeDestroy () {
    // this.clear()
  }
}
</script>
